import React from 'react';

import { Link } from 'react-router-dom'
import { useEffect } from 'react';

export default function TbtPage() {
	
	useEffect(() => {
		document.title = "TbT: RedPanda Fencing"
		window.scrollTo(0,0);
	}, []);
	
	return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">

		{/* Header Section */}
		<section className="text-center mb-8">
			<div className="bg-gradient-to-r from-tbtred to-red-800 text-white rounded-2xl p-6 max-w-4xl mx-auto shadow-lg mb-6">
				<h1 className="text-3xl md:text-4xl font-bold mb-4">Touch By Touch Fencing App</h1>
				<p className="text-lg md:text-xl font-semibold mb-4">A state of the art mobile and web-based application for scoring and recording fencing dual meets</p>
				<Link 
					to="https://tbtfencing.com" 
					className="inline-block bg-white text-tbtred px-6 py-3 rounded-xl font-bold hover:bg-gray-100 transition-colors duration-200 shadow-md" 
					target="_blank"
				>
					Visit Main Website
				</Link>
			</div>
		</section>

		{/* Apps Section - Side by Side on Desktop */}
		<section className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
			
			{/* High School Card */}
			<div className="bg-white border-2 border-gray-200 rounded-3xl p-6 shadow-lg">
				<h2 className="text-2xl md:text-3xl text-center font-extrabold mb-4 text-gray-800">High School</h2>
				
				<div className="mb-4">
					<iframe 
						width="100%" 
						height="500" 
						src="https://hs.tbtfencing.com" 
						frameBorder="0" 
						className="mx-auto border-4 border-tbtred rounded-xl shadow-md" 
						allowFullScreen
					/>
				</div>
				
				<div className="space-y-3">
					<Link 
						to="https://apps.apple.com/us/app/touch-by-touch/id1530755543" 
						className="block w-full bg-black text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors duration-200 text-center shadow-md" 
						target="_blank"
					>
						Download on App Store
					</Link>
					
					<Link 
						to="https://play.google.com/store/apps/details?id=live.touchbytouch&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" 
						className="block w-full bg-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-green-700 transition-colors duration-200 text-center shadow-md" 
						target="_blank"
					>
						Download on Play Store
					</Link>
				</div>
			</div>

			{/* College Card */}
			<div className="bg-white border-2 border-gray-200 rounded-3xl p-6 shadow-lg">
				<h2 className="text-2xl md:text-3xl text-center font-extrabold mb-4 text-gray-800">College</h2>
				
				<div className="mb-4">
					<iframe 
						width="100%" 
						height="500" 
						src="https://college.tbtfencing.com" 
						frameBorder="0" 
						className="mx-auto border-4 border-tbtred rounded-xl shadow-md" 
						allowFullScreen
					/>
				</div>
				
				<div className="space-y-3">
					<Link 
						to="https://apps.apple.com/us/app/touch-by-touch-college-fencing/id6451499719" 
						className="block w-full bg-black text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors duration-200 text-center shadow-md" 
						target="_blank"
					>
						Download on App Store
					</Link>
					
					<Link 
						to="https://play.google.com/store/apps/details?id=live.touchbytouchcollege" 
						className="block w-full bg-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-green-700 transition-colors duration-200 text-center shadow-md" 
						target="_blank"
					>
						Download on Play Store
					</Link>
				</div>
			</div>

		</section>

	</div>
}
